// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey:            "AIzaSyDcKmCexHWa4L3jKmB27LZ43JCs7OIfhNE",
  authDomain:        "brooklyn-bagels-co.firebaseapp.com",
  projectId:         "brooklyn-bagels-co",
  storageBucket:     "brooklyn-bagels-co.firebasestorage.app",
  messagingSenderId: "996160065021",
  appId:             "1:996160065021:web:0716d9ddc4595ab1a39d94",
  measurementId:     "G-4ZZQENMLVS",
};

const app       = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
